<template>
  <div>
    <div
      class="modal fade"
      id="SignupModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
														data-test="vendorSignUpModalHead"
            >
              {{modalTexts.modalTitle}}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="modalClose"
														data-test="vendorSignUpModalCloseBtn"
														id="vendorSignUpModalCloseBtn"
            >
              <span aria-hidden="true"
																				data-test="vendorSignUpModalCloseSpan"
																				id="vendorSignUpModalCloseSpan">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- Modal Body -->
            <div class="row m-0">
              <div class="col-12">
                <vendor-sign-up-form
                  :referVendorForm="referVendorForm"
                  :existingCustomerForm="existingCustomerForm"
                  :email="email"
                  :from="from"
                  :vendorAccount="vendorAccount"
                  :show="show"
                  :showPassword="showPassword"
                  :viewOrEdit="viewOrEdit"
                  :fieldNotEditable="fieldNotEditable"
                  @referVendor="referVendor($event)"
                  @updateVendorInfo="updateVendorInfo($event)"
                  @vendorSignUp="vendorSignUp($event)"
                  @existingCustomer="existingCustomerVendorSignUp($event)"
                  @signUpModalClose="modalClose"
                >
                </vendor-sign-up-form>
              </div>
            </div>
            <!-- Modal Body -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VendorSignUpForm from '@/components/pages/vendor/forms/VendorSignUpForm'

export default {
	name: 'vendor-sign-up-modal',
	components: {
		VendorSignUpForm
	},
	props: {
		email: null,
		from: null,
		vendorAccount: {},
		show: {
			type: Boolean,
			default: false
		},
		showPassword: {
			type: Boolean,
			default: true
		},
		viewOrEdit: {
			type: String,
			default: ''
		},
		fieldNotEditable: {
			type: Boolean,
			default: true
		},
		referVendorForm: {
			default: false,
			type: Boolean
		},
		existingCustomerForm: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		modalTexts () {
			const referVendorPageText = {
				modalTitle: 'Refer Vendor',
				submitButton: 'Refer'
			}
			const newVendorPageText = {
				modalTitle: 'Register',
				submitButton: 'Save changes'
			}
			if (this.referVendorForm) {
				return referVendorPageText
			}
			return newVendorPageText
		}
	},
	data () {
		return {
			showSignUpError: false,
			account: {
				documents: ''
			},
			phnError: false,
			imageUploadUrl: {},
			fileName: '',
			location: {
				latitude: 400,
				longitude: 400
			},
			selectedLocation: {},
			locationList: [],
			/* Form list for New venodr Sign Up */
			newUserFieldList: {
				enableAll: true
			},
			/* Form list for refer venodr */
			referVendorFieldList: {
				firstname: true,
				lastname: true,
				email: true,
				phone_number: true,
				address_line1: true,
				address_line2: true
			}
		}
	},
	methods: {
		existingCustomerVendorSignUp (vendorAdditionalInfo) {
			vendorAdditionalInfo.vendor_name = vendorAdditionalInfo.username
			vendorAdditionalInfo.username = vendorAdditionalInfo.email
			delete vendorAdditionalInfo.email
			this.$emit('existingCustomerVendorSignUp', vendorAdditionalInfo)
		},
		updateVendorInfo (updatedAccount) {
			this.$emit('updateVendorInfo', updatedAccount)
		},
		referVendor (vendorData) {
			this.$emit('referVendor', vendorData)
		},
		vendorSignUp (vendorInfo) {
			this.$emit('vendorSignUp', vendorInfo)
		},
		selectoption (event) {
			this.account.identity_proof = event.target.value
		},
		modalClose () {
			this.$emit('vendorSignUpModalClose')
		},
		getVendorLocation () {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition((loc) => {
					this.location = {
						latitude: loc.coords.latitude,
						longitude: loc.coords.longitude
					}
					setTimeout(() => {
						this.showMap = false
					}, 1000)
				})
			} else {
				alert('Geolocation is not supported by this browser.')
			}
		}
	},
	watch: {
		email () {
			if (this.from === 'noVendorCustomer') {
				this.account.email = this.email
			}
		},
		vendorAccount () {
			if (this.vendorAccount !== undefined && this.vendorAccount !== null) {
				this.account = this.vendorAccount
				this.account.username = this.vendorAccount.user_name
				this.account.email = this.vendorAccount.vendor_email
				this.location = {
					longitude: this.vendorAccount.longitude,
					latitude: this.vendorAccount.latitude
				}
			}
		},
		location () {
			setTimeout(() => {
				// Creating map options
				//
				// const mapOptions = {
				//   center: [this.location.latitude, this.location.longitude],
				//   zoom: 10,
				// };
				//   // Creating a map object
				// const map = new L.map('map', mapOptions);
				//
				// // Creating a Layer object
				// const layer = new L.TileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png');
				// // const layer = new L.TileLayer('http://192.168.2.29:8080/styles/osm-bright/{z}/{x}/{y}.png');
				//
				// // Adding layer to the map
				// map.addLayer(layer);
				//
				// // Add Leaflet Marker
				// // Icon options
				// const iconOptions = {
				//   iconUrl: 'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
				//   iconSize: [38, 38],
				// };
				//
				//   // Creating a custom icon
				// const customIcon = L.icon(iconOptions);
				// // Creating a marker
				// let markerOptions = {};
				// if (this.viewOrEdit !== '') {
				//   markerOptions = {
				//     title: 'MyLocation',
				//     clickable: false,
				//     draggable: false,
				//     icon: customIcon,
				//   };
				// } else {
				//   markerOptions = {
				//     title: 'MyLocation',
				//     clickable: true,
				//     draggable: true,
				//     icon: customIcon,
				//   };
				// }

				// multiple markers creation to denote different bakkalas in a location

				//   const marker = [];
				//   this.locationList.forEach((locationData, index) => {
				//
				//     marker[index] = L.marker([locationData.latitude, locationData.longitude], markerOptions);
				//     // Adding marker to the map
				//     marker[index].addTo(map).on('click', (e) => {
				//
				//     });
				//   });
				// const marker = L.marker([this.location.latitude, this.location.longitude], markerOptions);
				// // Adding marker to the map
				// marker.addTo(map).on('click', (e) => {
				//   this.selectedLocation = e.latlng;
				//
				// });
			}, 100)
		},
		selectedLocation () {
			this.account.latitude = this.selectedLocation.lat

			this.account.longitude = this.selectedLocation.lng
		}
	}
}
</script>
